import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers";
// import { composeWithDevTools } from "redux-devtools-extension";

const rootReducer = reducers;
const store = createStore(rootReducer);
export default store;
